export const BASE_URL = 'https://api.swapuz.com';

export const PRO_URL = 'https://r.swapuz.pro/gosite';

export const PROD_URL = 'https://r.swapuz.pro/goreg'
